import { render, staticRenderFns } from "./TipoMateriaPrima.vue?vue&type=template&id=6a8d7005&"
import script from "./TipoMateriaPrima.vue?vue&type=script&lang=js&"
export * from "./TipoMateriaPrima.vue?vue&type=script&lang=js&"
import style0 from "./TipoMateriaPrima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports